<template>
  <div class="login-page">
    <div class="login-page-left">
      <div class="login-page-left-content">
        <img src="@/static/login/login-title.png" />
      </div>
    </div>
    <div class="login-page-right"></div>
    <div class="login-box">
      <div class="login-box-inner">
        <div class="login-box-title" v-if="businessType === 'login'">
          <div class="login-box-t1">欢迎登录</div>
          <div class="login-box-t2">云滴出行 随心而行</div>
        </div>
        <div class="login-box-title" v-else>
          <div class="login-box-t1">忘记密码</div>
          <div class="login-box-t2">新密码将通过短信形式发送到对应手机号</div>
        </div>

        <login-panel />
      </div>
    </div>
  </div>
</template>

<script >
import LoginPanel from './components/login-panel.vue';
import { ref, provide } from '@vue/composition-api';

// login 登录  forgetPwd 忘记密码
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const businessType = ref('login');
  provide('businessType', businessType);
  return {
    businessType
  };
};
__sfc_main.components = Object.assign({
  LoginPanel
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .login-page {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    &-left {
      z-index: 1;
      position: relative;
      height: 100%;
      width: 55%;
      background: url('/cdn/img/login_bk.jpg') no-repeat;
      background-size: cover;
      overflow: hidden;
      &-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 20%;
        height: 123px;
        display: flex;
        justify-content: center;
        & > img {
          height: 123px;
          width: 502px;
        }
      }
    }
    &-right {
      height: 100%;
      width: calc(100% - 1064px);
    }
    .login-box {
      z-index: 2;
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
      &-title {
        margin-bottom: 32px;
        width: 500px;
        display: flex;
        align-items: flex-end;
      }
      &-t1 {
        font-size: 30px;
        font-weight: 700;
        color: #333333;
        letter-spacing: 0.15px;
      }
      &-t2 {
        margin-left: 23px;
        font-size: 18px;
        font-weight: 500;
        color: #999999;
      }
    }
    @media screen and (min-width: 768px) and (max-width: 1336px) {
      .login-page {
        &-left {
          width: 100%;
          &-content {
            display: none;
          }
        }
      }
      .login-box {
        width: 100%;
      }
    }
    @media screen and (max-width: 767px) {
      &-left {
        width: 0;
        &-content {
          display: none;
        }
      }
      .login-box {
        width: 100%;
      }
    }
  }
</style>
